<div class="size-container">
  <span>{{ toolName }} Size: {{ size }}</span>
  <!-- TODO: The 'tickInterval' property no longer exists -->
  <mat-slider
    [step]="sliderSettings.step"
    [min]="sliderSettings.min"
    [max]="sliderSettings.max"
    (click)="$event.stopPropagation()"
   #ngSlider><input [(ngModel)]="size" matSliderThumb (change)="onSizeChanged()" />
  </mat-slider>
</div>
<div class="switch-container">
  <button
    mat-icon-button
    class="switch-btn"
    [ngClass]="!isPointerShapeCircle() ? 'small' : 'left-active active'"
    (click)="onSwitchBtnClick(true); $event.stopPropagation()"
  >
    <mat-icon svgIcon="circle"></mat-icon>
  </button>
  <mat-icon
    [svgIcon]="!isPointerShapeCircle() ? 'arrows-right' : 'arrows-left'"
    class="arrows"
    [ngClass]="!isPointerShapeCircle() ? 'left' : 'right'"
  ></mat-icon>
  <button
    mat-icon-button
    class="switch-btn"
    [ngClass]="isPointerShapeCircle() ? 'small' : 'right-active active'"
    (click)="onSwitchBtnClick(false); $event.stopPropagation()"
  >
    <mat-icon svgIcon="square"></mat-icon>
  </button>
</div>
